<template>
  <div>
      <div class="columns is-centered box has-background-dvolightgrey mt-4">
          <div class="column is-two-thirds">
            <h1 class="is-size-3 has-text-white has-text-centered">Match Service Codes to Parts </h1>
              <b-field label="Enter the service code">
                    <b-taginput
                        :loading="isLoading"
                        v-model="serviceCode"
                        :data="filteredServices"
                        autocomplete
                        :allow-new="false"
                        :open-on-focus="true"
                        :closable="true"
                        field="code"
                        @typing="getFilteredServices">
                    <template v-slot="props">
                        <strong>{{props.option.code}}</strong>: {{props.option.description}}
                    </template>
                    <template #empty>
                        There are no items
                    </template>
                    </b-taginput>
              </b-field>
              <b-field label="Enter the product">
                    <b-taginput
                        :loading="isLoading"
                        v-model="productId"
                        :data="filteredProducts"
                        autocomplete
                        :allow-new="false"
                        :open-on-focus="true"
                        field="code"
                        @typing="getFilteredProducts">
                    </b-taginput>
              </b-field>
              <b-field label="Enter the part">
                    <b-taginput
                        :loading="isLoading"
                        v-model="partNumber"
                        :data="filteredParts"
                        autocomplete
                        :allow-new="false"
                        :open-on-focus="true"
                        field="number"
                        @typing="getFilteredParts">
                    </b-taginput>
              </b-field>
              <b-button @click="addServicePart()">Enter</b-button>
              <p class="has-text-danger is-size-3">{{ errorStatus }}</p>
          </div>
      </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { createServiceProductPart } from '../graphql/mutations'
import { getProducts, getServices, getParts } from '../graphql/queries'
export default {
    data(){
        return{
            products: [],
            services: [],
            parts: [],
            filteredProducts: [],
            filteredServices: [],
            filteredParts: [],
            productId: [],
            serviceCode: [],
            partNumber: [],
            isLoading: false,
            errorStatus: null
        }
    },
    methods: {
        async getServices() {
            const Services = await API.graphql({
                query: getServices,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.services = Services.data.getServices;
        },
        async getProducts() {
            const Products = await API.graphql({
                query: getProducts,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.products = Products.data.getProducts;
        },
        async getParts() {
            const Parts = await API.graphql({
                query: getParts,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.parts = Parts.data.getParts;
        },
        getFilteredProducts(text) {
            this.filteredProducts= this.products.filter((option) => {
                return option.code
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredParts(text) {
            this.filteredParts= this.parts.filter((option) => {
                return option.number
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredServices(text) {
            this.filteredServices= this.services.filter((option) => {
                return option.code
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        async addServicePart(){
            this.errorStatus = null;

            if(this.productId.length === 0 || this.partNumber.length === 0 || this.serviceCode.length === 0) {
                this.errorStatus = "Warning, all input fields must be filled with valid entries."
                return
            }

            this.isLoading = true
            // console.log(this.productId)
            // console.log(this.partNumber)
            // console.log(this.serviceCode)
            await API.graphql({
                query: createServiceProductPart,
                variables: {
                    input: {
                    product_id: this.productId[0].id,
                    part_number: this.partNumber[0].number,
                    service_code: this.serviceCode[0].code
                    }
                }
            });
            this.productId = [],
            this.partNumber = [],
            this.serviceCode = []
            
            this.isLoading = false
        }
    },
    mounted(){
        this.getProducts();
        this.getParts();
        this.getServices();
    }
}
</script>

<style>

</style>